import { Colors } from "@blueprintjs/core";
import styled from "@emotion/styled";

import { Box, Flex } from "@/components/layout/flexbox";
import { CustomerUser } from "@/types/users";

const Label = styled(Box)`
  margin-right: 24px;
  font-weight: 600;
  width: 205px;
`;

export function ClientDetail({ user }: { user: CustomerUser }) {
  return (
    <>
      <Flex alignItems="center">
        <Label>Email</Label>
        <Box
          width={1}
          style={{
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
          }}
        >
          {user.email}
        </Box>
      </Flex>
      <Flex mt="24px" alignItems="center">
        <Label>Phone</Label>
        <Box width={1}>
          {user.phoneNumber ? (
            <span>{user.phoneNumber}</span>
          ) : (
            <span style={{ color: Colors.LIGHT_GRAY3 }}>Empty</span>
          )}
        </Box>
      </Flex>
      <Flex mt={3} alignItems="center">
        <Label>LinkedIn</Label>
        <Box width={1}>
          {user.linkedinAccount ? (
            <a
              href={user.linkedinAccount}
              target="_blank"
              rel="noopener noreferrer"
            >
              {user.linkedinAccount}
            </a>
          ) : (
            <span style={{ color: Colors.LIGHT_GRAY3 }}>Empty</span>
          )}
        </Box>
      </Flex>
    </>
  );
}
